// ============================================================================
// 추적성 React Query 훅 (CHG-047)
// ============================================================================

import { useQuery } from '@tanstack/react-query';
import * as traceApi from '../services/traceabilityService';

export const traceabilityKeys = {
  matrix: (projectId: string, params?: Record<string, string>) => ['traceability', 'matrix', projectId, params] as const,
  issueChain: (projectId: string, issueId: string) => ['traceability', 'issue-chain', projectId, issueId] as const,
  reqChain: (projectId: string, reqId: string) => ['traceability', 'req-chain', projectId, reqId] as const,
};

export function useTraceabilityMatrix(projectId: string, params?: Record<string, string>) {
  return useQuery({
    queryKey: traceabilityKeys.matrix(projectId, params),
    queryFn: () => traceApi.fetchTraceabilityMatrix(projectId, params),
    enabled: !!projectId,
  });
}

export function useIssueTraceChain(projectId: string, issueId: string) {
  return useQuery({
    queryKey: traceabilityKeys.issueChain(projectId, issueId),
    queryFn: () => traceApi.fetchIssueTraceChain(projectId, issueId),
    enabled: !!projectId && !!issueId,
  });
}

export function useRequirementTraceChain(projectId: string, reqId: string) {
  return useQuery({
    queryKey: traceabilityKeys.reqChain(projectId, reqId),
    queryFn: () => traceApi.fetchRequirementTraceChain(projectId, reqId),
    enabled: !!projectId && !!reqId,
  });
}
